class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    // var self = this;
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      const item = cartItems.querySelector(
        `.cart-item:nth-child(${this.dataset.index})`
      );
      if (item.hasAttribute("data-saleclub")) {
        if (item.getAttribute("data-saleclub") === "true") {
          const productId = item.getAttribute("data-item-product-id");
          item.classList.add("hidden");
          //console.log("Product ID: " + productId);
          cartItems.unlockItem(productId);

          if (item) {
            cartItems.updateQuantity(this.dataset.index, 0);
          }
        } else {
          cartItems.updateQuantity(this.dataset.index, 0);
        }
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    // Add a map to track intervals for each product
    this.countdownIntervals = new Map();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    var self = this;
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.setCountdownOnAllItems();
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
          })
        );
        return;
        if (event.source === "cart-items") {
          this.setCountdownOnAllItems();
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    // Clean up all intervals when component is disconnected
    this.countdownIntervals.forEach((interval) => {
      clearInterval(interval);
    });
    this.countdownIntervals.clear();
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    console.log("onCartUpdate started");
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          console.log("-- ON CART UPDATE DONE");

          this.setCountdownOnAllItems();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          //console.log("update 2");
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
          this.setCountdownOnAllItems();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }

  setCountdownOnAllItems() {
    console.log("setCountdownOnAllItems");
    var self = this;
    const cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");
    //console.log("dumping cart items");
    //console.log(cartItems);
    cartItems.querySelectorAll(".cart-item").forEach((item) => {
      //check if item has attribute data-saleclub of true.
      if (item.hasAttribute("data-saleclub")) {
        if (item.getAttribute("data-saleclub") === "true") {
          console.log("saleclub");
          self.setCountdown(item);
        } else {
          console.log("no saleclub");
        }
      }
    });
  }

  setCountdown(item) {
    console.log("setCountdown");
    var item_id = item.id;
    var variant_id = item.getAttribute("data-item-product-id");
    var index = Array.from(item.parentNode.children).indexOf(item) + 1;
    console.log("Item index:", index);
    console.log("set Countdown");

    // Clear existing interval for this item if it exists
    if (this.countdownIntervals.has(variant_id)) {
      clearInterval(this.countdownIntervals.get(variant_id));
    }

    // check the cookie exists like so DrumShopSaleClub-264226637 - the number is the product id of the item. You can get the product id from attribute data-item-product-id from the cart item
    // var item_id = item.getAttribute("data-item-product-id");
    //console.log("Readin Cookie Response for: DrumShopSaleClub-" + variant_id);
    //console.log(readSaleCookie("DrumShopSaleClub-" + variant_id));
    var time_left = readSaleCookie("DrumShopSaleClub-" + variant_id);
    if (time_left) {
      //console.log("-- cookie exists!");
      var now = Date.now();
      var timeRemaining = time_left - now;
      var minutes = Math.floor(timeRemaining / 60000)
        .toString()
        .padStart(2, "0");
      var seconds = Math.floor((timeRemaining % 60000) / 1000)
        .toString()
        .padStart(2, "0");

      // if the cookie exists, set the countdown timer
      var banners = this.querySelectorAll(
        '[data-item-product-id="' + variant_id + '"] .saleclub-banner'
      );
      banners.forEach((banner) => {
        var minuteEl = banner.querySelector(".minute");
        var secondseEl = banner.querySelector(".second");
        minuteEl.textContent = minutes;
        secondseEl.textContent = seconds;
      });

      // Store interval in the map using variant_id as key
      this.countdownIntervals.set(
        variant_id,
        setInterval(() => {
          console.log("--- interval for variant: " + variant_id);
          timeRemaining -= 1000;
          if (timeRemaining <= 0) {
            clearInterval(this.countdownIntervals.get(variant_id));
            this.countdownIntervals.delete(variant_id);
            this.updateQuantity(index, 0);
            this.unlockItem(variant_id);
          } else {
            banners.forEach((banner) => {
              var minuteEl = banner.querySelector(".minute");
              var secondseEl = banner.querySelector(".second");
              const minutes = Math.floor(timeRemaining / 60000)
                .toString()
                .padStart(2, "0");
              const seconds = Math.floor((timeRemaining % 60000) / 1000)
                .toString()
                .padStart(2, "0");
              minuteEl.textContent = minutes;
              secondseEl.textContent = seconds;
            });
          }
        }, 1000)
      );
    } else {
      //console.log("-- no time left, should remove");
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      if (
        document.querySelector(
          ".cart-items [data-item-product-id='" + variant_id + "']"
        )
      ) {
        cartItems.updateQuantity(index, 0);
      }

      // this.onCartUpdate();
    }

    //
  }

  // lockItem() {}

  unlockItem(product_id) {
    // Clear the interval for this product when it's unlocked
    if (this.countdownIntervals.has(product_id)) {
      clearInterval(this.countdownIntervals.get(product_id));
      this.countdownIntervals.delete(product_id);
    }

    //console.log("unlocking item: " + product_id);
    var productId = product_id;
    var hasCookie = readSaleCookie("DrumShopSaleClub-" + productId);
    if (hasCookie != null) {
      //console.log("cookie exists, should remove");
      eraseSaleCookie("DrumShopSaleClub-" + productId);
    }

    //submit request to API

    fetch("https://saleclub.sale/api/unlock", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        // "Access-Control-Allow-Origin": "*",
      },
      body: new URLSearchParams({
        product_id: productId,
      }).toString(),
    })
      .then((response) => {
        //console.log(
        //"-- checking if unlock worked, dumping response below this:"
        //);
        //console.log(response);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // Try to parse as JSON if possible, otherwise just use text response
        return response.text().then((text) => {
          try {
            return JSON.parse(text);
          } catch (e) {
            //console.log("-- Response is not valid JSON:", text);
            return text;
          }
        });
      })
      .then((_) => {
        //console.log("-- success, unlocked");
        // document.getElementById("p" + productId).classList.remove("locked");
        if (document.querySelector('[data-product-id="' + productId + '"]')) {
          document
            .querySelector('[data-product-id="' + productId + '"]')
            .locallyUnlockItem();
        }

        // this.setCountdownOnAllItems();
      })

      .catch((error) => {
        console.error("-- Error:", error);
      });
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
